import Rest from '../Rest'

export default class UserAccessLogService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/user_access_logs'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}

